module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "acknowPage"
  }, [_c('div', {
    staticClass: "title-acknowPage"
  }, [_c('a', {
    attrs: {
      "href": "#/e9781466815070_toc01#toctitle1",
      "id": "title1"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("ACKNOWLEDGMENTS")])])])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("As much as I would like to, it would be impossible for me to thank all the people who have helped me with this book.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("I must be content with expressing my heartfelt thanks to my husband, Robert Alan Keisman, M.D., cardiologist, for his exhaustive contribution to the medical content of this book. My deepest gratitude to Dr. Herbert C. Kraft, professor of anthropology and director of the Archeological Research Center and Museum at Seton Hall University, for his careful reading of my manuscript and his willingness to share with me his vast knowledge of the Lenni-Lenape Indians. And to Fred Kafes, medical librarian at Our Lady of Lourdes Medical Center, Camden, New Jersey, my thanks for providing essential medical material.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("To all the rest—family and friends, mystery writers and mystery readers, editors and agents—please know that I am profoundly grateful for all your help, and I wish I could thank each of you individually.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-844c8ebc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781466815070_ack01.vue
// module id = 66
// module chunks = 0